import { Box, styled } from '@mui/material';

const ActionButtonsGroup = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    height: 'fit-content',

    '& > button': {
        flexGrow: 1
    }
}));

export default ActionButtonsGroup;
